export default {
  reservation_statuses: []
}
